import React from 'react';
import Uganda_p2 from './uganda_p2';
import Uganda_p2_subjects from './uganda_p2_subjects';
const Uganda_p2eng = () => {
  return (
    <div>
     <Uganda_p2 />
    <Uganda_p2_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1> English</h1>
      <h3>English content</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in English learning and assessment </li>
      <li>Cross-cutting isues integrated in English learning and assessment </li>
      <li>Values integrated in English learning and assessment </li>
    </div>  
    </div>
  );
}

export default Uganda_p2eng;